const init = () => {
  const stickyMenuElm = document.querySelector('.js-stickyMenu');
  if (!stickyMenuElm) return;

  // 最上部から50pxスクロールしたら.is-hiddenを削除する
  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      stickyMenuElm.classList.add('is-active');
    } else {
      stickyMenuElm.classList.remove('is-active');
    }
  });

  // footerが画面領域に入ったら,.is-hiddenを付与する
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      stickyMenuElm.classList.add('is-hidden');
    } else {
      stickyMenuElm.classList.remove('is-hidden');
    }
  }, { threshold: 0 });

  observer.observe(document.querySelector('#js-footer'));
}

export { init };
